import './GridRowInnerBoxTitle.css';

const GridRowInnerBoxTitle = ({title}) => {
    return(
        <h2 className="text-center inner-box-title">{title}</h2>
    )
}

export { GridRowInnerBoxTitle }